'use strict';

var jsxRuntime = require('@emotion/react/jsx-runtime');
var react = require('@emotion/react');
var index = require('../../../aviary-core/dist/cjs/index.cjs');

/**
 * SVG Illustration of lab results
 */ const LabResults = ({ assetColor = index.ASSET_COLORS.grey, size = index.ILLUSTRATION_DIMENSIONS.medium, ...rest })=>{
    const theme = react.useTheme();
    return /*#__PURE__*/ jsxRuntime.jsxs("svg", {
        width: size,
        height: size,
        viewBox: "0 0 104 104",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...rest,
        children: [
            /*#__PURE__*/ jsxRuntime.jsx("circle", {
                cx: "52",
                cy: "52",
                r: "52",
                fill: theme.ds5.asset[assetColor].background
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M59.899 17.8511L24.6015 24.376C22.065 24.8448 20.3815 27.2905 20.8506 29.828L30.0081 79.3675C30.4772 81.905 32.9237 83.5873 35.4602 83.1184L70.7577 76.5935C73.2952 76.1244 74.9775 73.6779 74.5086 71.1414L65.3511 21.602C64.882 19.0645 62.4355 17.3822 59.899 17.8511Z",
                fill: theme.ds5.asset[assetColor]["500"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M70.6215 26.9668H34.7746C32.1987 26.9668 30.1016 29.0676 30.1016 31.6503V82.0728C30.1016 84.6555 32.1987 86.7563 34.7746 86.7563H70.6215C73.1985 86.7563 75.2945 84.6545 75.2945 82.0728V31.6503C75.2945 29.0676 73.1974 26.9668 70.6215 26.9668Z",
                fill: theme.ds5.asset[assetColor]["100"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M70.5199 27H34.6731C32.0971 27 30 29.1008 30 31.6835V82.106C30 84.6887 32.0971 86.7895 34.6731 86.7895H70.5199C73.0969 86.7895 75.193 84.6877 75.193 82.106V31.6835C75.193 29.1008 73.0958 27 70.5199 27Z",
                fill: theme.ds5.asset[assetColor]["100"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("rect", {
                x: "35.6172",
                y: "40.9082",
                width: "28",
                height: "2",
                rx: "1",
                fill: theme.ds5.asset[assetColor]["500"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("rect", {
                x: "35.6172",
                y: "64.9082",
                width: "30",
                height: "2",
                rx: "1",
                fill: theme.ds5.asset[assetColor]["500"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("rect", {
                x: "35.6172",
                y: "52.9082",
                width: "30",
                height: "2",
                rx: "1",
                fill: theme.ds5.asset[assetColor]["500"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("rect", {
                x: "35.6172",
                y: "76.9082",
                width: "34",
                height: "2",
                rx: "1",
                fill: theme.ds5.asset[assetColor]["500"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("rect", {
                x: "35.6172",
                y: "34.9082",
                width: "34",
                height: "2",
                rx: "1",
                fill: theme.ds5.asset[assetColor]["500"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("rect", {
                x: "35.6172",
                y: "58.9082",
                width: "30",
                height: "2",
                rx: "1",
                fill: theme.ds5.asset[assetColor]["500"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("rect", {
                x: "35.6172",
                y: "46.9082",
                width: "30",
                height: "2",
                rx: "1",
                fill: theme.ds5.asset[assetColor]["500"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("rect", {
                x: "35.6172",
                y: "70.9082",
                width: "30",
                height: "2",
                rx: "1",
                fill: theme.ds5.asset[assetColor]["500"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M69.6172 42.9082H81.6172V69.9082C81.6172 73.2219 78.9309 75.9082 75.6172 75.9082C72.3035 75.9082 69.6172 73.2219 69.6172 69.9082V42.9082Z",
                fill: theme.ds5.asset[assetColor]["500"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("rect", {
                x: "67.6172",
                y: "40.9082",
                width: "16",
                height: "2",
                rx: "1",
                fill: theme.ds5.asset[assetColor]["500"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M69.6172 42.9082H81.6172V49.9082H69.6172V42.9082Z",
                fill: theme.ds5.asset[assetColor]["600"]
            })
        ]
    });
};

exports.LabResults = LabResults;
//# sourceMappingURL=LabResults.cjs.map
